<template>
  <div class="confirm-approve-wow-streamer-wrapper">
    <b-form @submit.prevent="submitForm">
      <h5>Одобрить заявку стримера?</h5>
      <p class="subtext">После одобрения, стримера можно будет найти в подразделе "Пользователи".</p>
      <b-alert v-if="errorText" show variant="danger" class="mt-3">{{ errorText }}</b-alert>
      <footer>
        <b-button type="submit" :disabled="isLoadingSaveForm" variant="primary" class="m-1">
          {{ isLoadingSaveForm ? 'В процессе...' : 'ОК' }}
        </b-button>
        <b-button @click="$emit('closeModal')" variant="secondary" class="m-1">
          Отмена
        </b-button>
      </footer>
    </b-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { WowStreamersAdapterMixin } from "@/mixins/WowStreamers/WowStreamersAdapterMixin";

export default {
  name: "ConfirmApproveWowStreamer",
  mixins: [WowStreamersAdapterMixin],
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoadingSaveForm: false,
      errorText: null,
    };
  },
  methods: {
    ...mapActions(['approveWowStreamer', 'fetchWowStreamerEntries']),
    async submitForm() {
      try {
        this.isLoadingSaveForm = true;
        this.errorText = null;
        await this.approveWowStreamer(this.params.id);
        this.$emit("closeModal");
        this.$emit("actionSuccess");
        this.$toast.success('Заявка одобрена', { position: 'top-right' });
        this.fetchWowStreamerEntries({ pageNumber: this.getCurrentPage });
      } catch (e) {
        this.errorText = e.response.data.message;
        this.$toast.error(`Ошибка при одобрении стримера: ${this.errorText}`, { position: 'top-right' });
      } finally {
        this.isLoadingSaveForm = false;
      }
    },
  },
};
</script>

<style scoped>
.confirm-approve-wow-streamer-wrapper {
  footer {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin-top: 15px;
    text-align: right;
  }
}
</style>
